<template>
    <div class="pb-10 pb-sm-16">
        <h2 class="title d-flex align-center justify-center pb-sm-5 pb-3 pl-10">
            <span>考試範圍</span>
            &nbsp;
            <img
                src="../assets/V.png"
                width="50"
            >
        </h2>
        <div
            class="pa-5"
            style="max-width: 1000px; margin: auto"
        >
            <template v-for="(subjects, grade) in list">
                <div
                    :key="grade"
                    class="d-flex flex-column align-center"
                    style="position: relative"
                >
                    <h3 class="list-type-title mt-10">
                        {{ grade }}
                    </h3>
                    <div
                        v-for="(item, j) in subjects"
                        :key="j"
                        class="d-flex downloadScope"
                        style="width: 100%;"
                    >
                        <v-btn
                            v-if="item.subject ==='命題範圍'"
                            outlined
                            color="var(--color-primary)"
                            :disabled="list.length===0?true:false"
                            :href="$static(item.pdfLink)"
                            target="_blank"
                        >
                            下載前一屆參考試題
                            <span class="material-icons-outlined md-18">file_download</span>
                        </v-btn>
                    </div>
                    <v-expansion-panels class="mt-2">
                        <v-expansion-panel
                            v-for="(item, j) in subjects"
                            :key="j"
                        >
                            <v-expansion-panel-header v-if="item.subject !=='命題範圍'">
                                <h3>{{ item.subject }}</h3>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                                class="content"
                                style="padding: 1em;"
                            >
                                <ol
                                    class="mb-3"
                                    style="font-weight: lighter"
                                >
                                    <li
                                        v-for="(scope, k) in item.examScopeList"
                                        :key="k"
                                    >
                                        {{ scope }}
                                    </li>
                                </ol>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            list: [],
        };
    },
    computed: {
        ...mapState('mActivity', ['activityData']),
    },
    watch: {
        // eslint-disable-next-line func-names
        'activityData.id': function () {
            this.handleList();
        },
    },
    created() {
        if (this.activityData.id) {
            this.handleList();
        }
    },
    methods: {
        ...mapActions('mScope', ['List']),
        handleList() {
            const params = {
                filter: `activity:${this.activityData.id}`,
            };
            this.List(params).then((res) => {
                // 原本的分組邏輯
                const groupedData = res.data?.raw?.reduce((obj, item) => {
                    if (obj[item.grade]) obj[item.grade].push(item);
                    // eslint-disable-next-line no-param-reassign
                    else obj[item.grade] = [item];
                    return obj;
                }, {});

                // 年級排序對應表
                const gradeOrder = {
                    一年級: 1,
                    二年級: 2,
                    三年級: 3,
                    四年級: 4,
                    五年級: 5,
                    六年級: 6,
                };

                // 轉換為陣列並排序
                const sortedEntries = Object.entries(groupedData).sort((a, b) => {
                    const gradeA = gradeOrder[a[0]];
                    const gradeB = gradeOrder[b[0]];

                    // 如果兩個都有對應的順序，按順序排列
                    if (gradeA !== undefined && gradeB !== undefined) {
                        return gradeA - gradeB;
                    }
                    // 如果只有 A 有對應順序，A 排前面
                    if (gradeA !== undefined && gradeB === undefined) {
                        return -1;
                    }
                    // 如果只有 B 有對應順序，B 排前面
                    if (gradeA === undefined && gradeB !== undefined) {
                        return 1;
                    }
                    // 如果兩個都沒有對應順序，按字母順序排列
                    return a[0].localeCompare(b[0]);
                });

                // 科目排序對應表
                const subjectOrder = {
                    國語: 1,
                    英文: 2,
                    數學: 3,
                    自然: 4,
                    智力測驗: 5,
                    命題範圍: 6,
                };

                // 對每個年級的科目進行排序
                const sortedList = {};
                sortedEntries.forEach(([grade, subjects]) => {
                    const sortedSubjects = subjects.sort((a, b) => {
                        const subjectA = subjectOrder[a.subject];
                        const subjectB = subjectOrder[b.subject];

                        // 如果兩個都有對應的順序，按順序排列
                        if (subjectA !== undefined && subjectB !== undefined) {
                            return subjectA - subjectB;
                        }
                        // 如果只有 A 有對應順序，A 排前面
                        if (subjectA !== undefined && subjectB === undefined) {
                            return -1;
                        }
                        // 如果只有 B 有對應順序，B 排前面
                        if (subjectA === undefined && subjectB !== undefined) {
                            return 1;
                        }
                        // 如果兩個都沒有對應順序，按字母順序排列
                        return a.subject.localeCompare(b.subject);
                    });
                    sortedList[grade] = sortedSubjects;
                });

                this.list = sortedList;
                console.log(this.list);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    height: 100px;
    position: relative;
    color: #fff;
    background-image: url("../assets/title.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    @media screen and (min-width: 600px) {
        height: 200px;
    }
}

.content{
    background-color: var(--color-primary-light);
    border-color: var(--color-primary-light);
}

.list-type-title {
    display: list-item;
    list-style-type: disc;
    margin-bottom: 10px;
    &::marker {
        color: var(--color-primary);
    }
    @media screen and (min-width: 600px) {
        margin-bottom: 25px;
    }
}
.downloadScope{
    justify-content: center;
    position: relative;
    @media screen and (min-width: 600px) {
        position: absolute;
        top: 55px;
        justify-content: flex-end;
    }
}
</style>
